import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlatformShutDownNotificationComponent } from './platform-shut-down-notification.component';
import { FiNotificationModule } from '../notification.module';
import { FiAppTextSharedModule } from '../../../shared/app-text';
import { PlatformShutDownNotificationService } from './platform-shut-down-notification.service';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    imports: [CommonModule, FiNotificationModule, FiAppTextSharedModule, MatIconModule, MatButtonModule],
    declarations: [PlatformShutDownNotificationComponent],
    providers: [PlatformShutDownNotificationService],
})
export class PlatformShutDownNotificationModule {}
